import Vue from 'vue';
import {
    BROADCAST_INIT,
    BROADCAST_CONNECT,
    BROADCAST_CONNECTED,
    BROADCAST_DISCONNECT,
    BROADCAST_DISCONNECTED,
    BROADCAST_RECONNECT,
} from '../actions';


const state = {
    status: '',
    isConnected: false,
};

const getters = {
    isBroadcastConnected: state => state.isConnected,
};

const actions = {
    [BROADCAST_INIT]: (context) => {
        // context.commit(BROADCAST_INIT);
        //
        // console.log('Socket connected @ BROADCAST_INIT start: ', Vue.prototype.$echo.connector.socket.connected, Vue.prototype.$echo.connector.socket.id);

    },
    [BROADCAST_CONNECT]: (context) => {
        // context.commit(BROADCAST_CONNECT);
        //
        // console.log('Socket connected @ BROADCAST_CONNECT start: ', Vue.prototype.$echo.connector.socket.connected, Vue.prototype.$echo.connector.socket.id);
        //
        // if (! Vue.prototype.$echo.connector.socket.connected) {
        //     console.log('socket is not connected, connecting...');
        //     Vue.prototype.$echo.connect();
        //     console.log('Socket connected @ BROADCAST_CONNECT reconnect: ', Vue.prototype.$echo.connector.socket.connected, Vue.prototype.$echo.connector.socket.id);
        // } else {
        //     console.log('CONNECTED @ CONNECT.');
        //     console.log('Socket already connected: ', Vue.prototype.$echo.connector.socket.connected, Vue.prototype.$echo.connector.socket.id);
        //     context.commit(BROADCAST_CONNECTED);
        // }
    },
    [BROADCAST_DISCONNECT]: (context) => {
        // if (context.state.isConnected || Vue.prototype.$echo.connector.socket.connected) {
        //     console.log('Socket connected before BROADCAST_DISCONNECT commit: ', Vue.prototype.$echo.connector.socket.connected, Vue.prototype.$echo.connector.socket.id);
        //     context.commit(BROADCAST_DISCONNECT);
        //     //Vue.prototype.$echo.disconnect();
        //     console.log('Socket connected before BROADCAST_DISCONNECTED commit: ', Vue.prototype.$echo.connector.socket.connected, Vue.prototype.$echo.connector.socket.id);
        //     context.commit(BROADCAST_DISCONNECTED);
        // }
    },
    [BROADCAST_RECONNECT]: (context) => {
        // context.dispatch(BROADCAST_DISCONNECT);
        // context.dispatch(BROADCAST_CONNECT);
    },
};

const mutations = {
    [BROADCAST_INIT]: (state) => {
        state.status = 'initializing';
        state.isConnected = false;
    },
    [BROADCAST_CONNECT]: (state) => {
        state.status = 'connecting';
    },
    [BROADCAST_CONNECTED]: (state) => {
        state.status = 'connected';
        console.log('Socket connected @ BROADCAST_CONNECTED mutation: ', Vue.prototype.$echo.connector.socket.connected, Vue.prototype.$echo.connector.socket.id);
        state.isConnected = true;
    },
    [BROADCAST_DISCONNECT]: (state) => {
        state.status = 'disconnecting';
        console.log('SocketIO disconnecting...', Vue.prototype.$echo.connector.socket.id);
    },
    [BROADCAST_DISCONNECTED]: (state) => {
        state.status = 'disconnected';
        state.isConnected = false;
        console.log('SocketIO disconnected.', Vue.prototype.$echo.connector.socket.id);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
    Vue,
};
